module.exports = "<div class=\"modal-header\">\n\t<button type=\"button\" class=\"close\" data-dismiss=\"close\" aria-label=\"Close\" ng-click=\"$dismiss()\"><span\n\t\t\taria-hidden=\"true\">&times;</span>\n\t</button>\n<div class=\"row\">{{msg.subject}}\n<div class=\"small-text\">{{msg.source}}   <span>|</span>  {{msg.timestamp | date :'medium'}}</div></div>\n\n</div>\n<div class=\"modal-body \">\n{{msg.error}}\n\n</div>\n\t<jf-clip-copy text-to-copy=\"msg.error\"\n\t              object-name=\"Error\"></jf-clip-copy>\n"


//////////////////
// WEBPACK FOOTER
// ./modules/xray/modal_templates/show_error_modal.html
// module id = 662
// module chunks = 6